import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Button,
  useTheme,
  Badge,
  IconButton,
  Grid,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";

import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { layouts } from "chart.js";
import zIndex from "@material-ui/core/styles/zIndex";
import _ from "lodash";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";

export interface BoxDetailsProps {}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      borderRadius: 10,
      padding: "0px 20px",
      height: "100%",
      border: "none",
    },
  }),
);

const EmptyWidgetBoxes: React.FunctionComponent<BoxDetailsProps> = ({}) => {
  const theme: CustomTheme = useTheme();
  return (
    <Grid container>
      <Grid item xs={12}></Grid>
    </Grid>
  );
};

export default EmptyWidgetBoxes;
